import { useEffect } from 'react';
import { useFormik } from 'formik';
import { Box } from '@mui/material';
import { Drawer, drawerType } from '../../../../../packages/ui/organisms/drawer';
import {
  Button,
  btnType,
  IconButton,
  Text,
  TextError,
  Checkbox,
  FormControlLabel,
} from '../../../../../packages';
import { sx } from './ModalitiesDrawer.styles';

export const ModalitiesDrawer = ({ isOpen, onClose, allModalities, modalities, onSubmit }) => {
  const { errors, values, handleChange, handleSubmit, touched, setFieldValue, ...rest } = useFormik({
    initialValues: {
      selectedModalities: modalities || [],
    },
    onSubmit: values => {
      onSubmit(values.selectedModalities);
      onClose();
    },
  });

  useEffect(() => {
    if (modalities && modalities.length > 0) {
      setFieldValue('selectedModalities', modalities);
    }
  }, [modalities]);

  const handleModalityChange = modality => {
    const currentSelectedModalities = [...values.selectedModalities];
    const index = currentSelectedModalities.indexOf(modality);

    if (index > -1) {
      currentSelectedModalities.splice(index, 1);
    } else {
      currentSelectedModalities.push(modality);
    }

    setFieldValue('selectedModalities', currentSelectedModalities);
  };

  return (
    <Drawer open={isOpen} onClose={onClose} variant={drawerType.NORMAL} sx={sx.drawer}>
      <Box sx={sx.wrapper}>
        <Box sx={sx.header}>
          <Text sx={sx.headerTitle}>Assign Modalities</Text>
          <IconButton icon="close" onClick={onClose} sx={sx.backBtn} />
        </Box>
        <Box sx={sx.form}>
          <form onSubmit={handleSubmit}>
            <Box sx={sx.formContent}>
              <Box sx={sx.section}>
                {allModalities.map((modality, index) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        checked={values.selectedModalities.includes(modality)}
                        onChange={() => handleModalityChange(modality)}
                      />
                    }
                    label={modality}
                  />
                ))}
                <TextError
                  errorMsg={touched.selectedModalities ? errors.selectedModalities?.toString() : null}
                />
              </Box>
            </Box>
            <Box sx={sx.footer}>
              <Button variant={btnType.TEXT} onClick={onClose}>
                Cancel
              </Button>
              <Button type="submit">Save</Button>
            </Box>
          </form>
        </Box>
      </Box>
    </Drawer>
  );
};
